import { gettext } from '@eventbrite/i18n';
import { PromotedListingsStatusMap } from './types';

export const PROMOTED_LISTING_STATUS_MAP: PromotedListingsStatusMap = {
    live: gettext('Live'),
    pending: gettext('Pending'),
    ended: gettext('Ended'),
    rejected: gettext('Rejected'),
    paused: gettext('Paused'),
    locked: gettext('Locked'),
    suspended: gettext('Suspended'),
};

export const COL_TYPE = {
    CAMPAIGNS: 'campaigns',
    START_DATE: 'start_date',
    END_DATE: 'end_date',
    IMPRESSIONS: 'impressions',
    CLICKS: 'clicks',
    SPEND: 'spend',
    STATUS_BADGE: 'statusBadge',
};

const {
    CAMPAIGNS,
    START_DATE,
    END_DATE,
    IMPRESSIONS,
    CLICKS,
    SPEND,
    STATUS_BADGE,
} = COL_TYPE;

export const COLUMNS = [
    {
        fieldName: CAMPAIGNS,
        fieldLabel: 'Campaigns',
        isEditable: false,
        isSortable: true,
        isFilterable: false,
    },
    {
        fieldName: START_DATE,
        fieldLabel: 'Start Date',
        isEditable: false,
        isSortable: true,
        isFilterable: false,
    },
    {
        fieldName: END_DATE,
        fieldLabel: 'End Date',
        isEditable: false,
        isSortable: true,
        isFilterable: false,
    },
    {
        fieldName: IMPRESSIONS,
        fieldLabel: 'Impressions',
        isEditable: false,
        isSortable: false,
        isFilterable: false,
    },
    {
        fieldName: CLICKS,
        fieldLabel: 'Clicks',
        isEditable: false,
        isSortable: false,
        isFilterable: false,
    },
    {
        fieldName: SPEND,
        fieldLabel: 'Spend',
        isEditable: false,
        isSortable: false,
        isFilterable: false,
    },
    {
        fieldName: STATUS_BADGE,
        fieldLabel: 'Status',
        isEditable: false,
        isSortable: true,
        isFilterable: false,
    },
];

export const VIEW_AND_MANAGE_CAMPAIGN = 'viewAndManageCampaign';
export const PAUSE_CAMPAIGN = 'pauseCampaign';
export const RESUME_CAMPAIGN = 'resumeCampaign';
export const END_CAMPAIGN = 'endCampaign';

export const ITEM_ACTIONS = [
    {
        value: VIEW_AND_MANAGE_CAMPAIGN,
        content: 'View Campaign',
    },
    {
        value: PAUSE_CAMPAIGN,
        content: 'Pause Campaign',
    },
    {
        value: RESUME_CAMPAIGN,
        content: 'Resume Campaign',
    },
    {
        value: END_CAMPAIGN,
        content: 'End Campaign',
    },
];

export const AD_STATUS = {
    ACTIVE: 1,
    PAUSED: 2,
    COMPLETE: 3,
    PENDING: 4,
    BLOCKED_FAILED_PAYMENT: 5,
    BLOCKED_CONTENT_MODERATION: 6,
    DELETED: 7,
    LOCKED: 8,
    BLOCKED_ADVERTISER_SUSPENDED: 9,
};

export const SIMPLE_ACTIONS_STATUSES = [
    AD_STATUS.COMPLETE,
    AD_STATUS.PENDING,
    AD_STATUS.BLOCKED_FAILED_PAYMENT,
    AD_STATUS.BLOCKED_CONTENT_MODERATION,
    AD_STATUS.DELETED,
];

export const ACTIVE_ACTIONS = [
    VIEW_AND_MANAGE_CAMPAIGN,
    PAUSE_CAMPAIGN,
    END_CAMPAIGN,
];
export const PAUSED_ACTIONS = [
    VIEW_AND_MANAGE_CAMPAIGN,
    RESUME_CAMPAIGN,
    END_CAMPAIGN,
];

export const ADVERTISER_STATUS = {
    ACTIVE: 1,
    BLOCKED_FAILED_PAYMENT: 5,
    BLOCKED_CONTENT_MODERATION: 6,
    DELETED: 7,
    BLOCKED_ADVERTISER_SUSPENDED: 9,
};

export const STATUSES = {
    PENDING: 'pending',
    LIVE: 'live',
    ENDED: 'ended',
    REJECTED: 'rejected',
    PAUSED: 'paused',
    LOCKED: 'locked',
    BLOCKED_ADVERTISER_SUSPENDED: 'suspended',
};

const {
    PENDING,
    LIVE,
    ENDED,
    REJECTED,
    PAUSED,
    LOCKED,
    BLOCKED_ADVERTISER_SUSPENDED,
} = STATUSES;

// @TODO: This might serve us better to be returned from the api
// as a string instead of integers.
export const CAMPAIGN_SERVICE_AD_STATUS_MAP: any = {
    1: STATUSES.LIVE,
    2: STATUSES.PAUSED,
    3: STATUSES.ENDED,
    4: STATUSES.PENDING,
    5: STATUSES.REJECTED,
    6: STATUSES.REJECTED,
    8: STATUSES.LOCKED,
    9: STATUSES.BLOCKED_ADVERTISER_SUSPENDED,
};

/**
 * Status key color
 */
export const STATUS_BADGE_COLOR: any = {
    default: 'eds-bg-color--ui-600',
    [PENDING]: 'eds-bg-color--edgy-yellow',
    [LIVE]: 'eds-bg-color--success',
    [ENDED]: 'eds-bg-color--ui-200',
    [REJECTED]: 'eds-bg-color--ui-orange--active',
    [PAUSED]: 'eds-bg-color--ui-600',
    [LOCKED]: 'eds-bg-color--ui-200',
    [BLOCKED_ADVERTISER_SUSPENDED]: 'eds-bg-color--ui-orange--active',
};

export const DEFAULT_BADGE_COLOR = 'eds-bg-color--ui-600';

export const SELECT_FILTER_ACTIONS = [
    {
        value: '1',
        display: 'Live',
    },
    {
        value: '2',
        display: 'Paused',
    },
    {
        value: '3',
        display: 'Ended',
    },
    {
        value: '4',
        display: 'Pending',
    },
    {
        value: '5',
        display: 'Rejected',
    },
    {
        value: '0',
        display: 'All',
    },
];
